module.exports = __webpack_public_path__ + "img/2.36a7b341.png";